import { render, staticRenderFns } from "./PeersDuration.vue?vue&type=template&id=65667faf&scoped=true"
import script from "./PeersDuration.vue?vue&type=script&lang=js"
export * from "./PeersDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65667faf",
  null
  
)

export default component.exports